export default "__VITE_ASSET__fa1f9daf__"